<script>
  import { onMount } from "svelte";
  import * as d3 from "d3";

  export let data = [];
  export let type; // String, what type of sparkline it is (state or district)

  const margin = { top: 5, right: 18, bottom: 20, left: 15 };
  let width = 90;
  let height = 40;

  let svgEl;
  let tooltipEl;

  function updateWidth() {
    let minInnerWidth = window.innerWidth < 500 ? 75 : 90;
    width = Math.min(minInnerWidth, window.innerWidth - 2);
    height = 40;
  }

  // --- Utility to fill missing months with 0 ---
  function groupByMonthsWithZeros(rows) {
    if (!rows.length) return [];

    const minDate = d3.timeMonth.floor(d3.min(data, d => new Date(d.date_filed)));
    const maxDate = d3.timeMonth.floor(d3.max(data, d => new Date(d.date_filed)));
    
    const now = new Date();
    const currentMonthStart = d3.timeMonth.floor(now);
    
    // Determine the last complete month
    const lastCompleteMonth = (maxDate >= currentMonthStart) 
      ? d3.timeMonth.offset(currentMonthStart, -1)  // Exclude current incomplete month
      : maxDate;  // Data is older, use as-is
    
    const allMonths = d3.timeMonths(minDate, d3.timeMonth.offset(lastCompleteMonth, 1));

    const rollup = d3.rollup(
      rows,
      v => v.length,
      d => d3.timeMonth.floor(new Date(d.date_filed))
    );

    const monthlyData = allMonths.map(month => ({
      date: month,
      count: rollup.get(month) || 0
    }));

    return monthlyData;
  }

  let x, y, xAxisGroup, yAxisGroup, linePath;

  function initChart() {
    if (!data.length) return;

    const svg = d3.select(svgEl);
    svg.selectAll("*").remove();

    const points = groupByMonthsWithZeros(data);

    // --- Scales ---
    x = d3.scaleTime()
      .domain([new Date("2025-01-01"), new Date("2026-01-02")])
      .range([margin.left, width - margin.right]);

    y = d3.scaleLinear()
      .domain([0, d3.max(points, d => d.count)])
      .nice()
      .range([height - margin.bottom, margin.top]);
      
       // --- X axis ---
    const xAxis = d3.axisBottom(x).tickValues([new Date("2025-01-02"), new Date("2026-01-02")]).tickFormat(
     type == "district" ? "" : d3.timeFormat("%b '%y"));
    xAxisGroup = svg.append("g")
      .attr("transform", `translate(0,${height - margin.bottom})`)
      .call(xAxis)
      .call(g => {
        g.select(".domain").attr("stroke", "none")
        g.selectAll(".tick line").attr("stroke", "var(--sparkline-text-colors)").attr("stroke-width", 1);
        g.selectAll(".tick text").style("font-size", "10px").style("fill", "var(--sparkline-text-colors)");
      });


    // --- Line ---
    const line = d3.line()
      .x(d => x(d.date))
      .y(d => y(d.count))
      .curve(d3.curveMonotoneX);

    linePath = svg.append("path")
      .datum(points)
      .attr("fill", "none")
      .attr("stroke", "var(--sparkline-line-colors)")
      .attr("stroke-width", 2)
      .attr("d", line);

  
  }

  function updateChart() {
    if (!data.length) return;

    const points = groupByMonthsWithZeros(data);

    const yNew = d3.scaleLinear()
      .domain([0, d3.max(points, d => d.count)])
      .nice()
      .range([height - margin.bottom, margin.top]);

    const yAxis = d3.axisLeft(yNew).ticks(3);
   
    const line = d3.line()
      .x(d => x(d.date))
      .y(d => yNew(d.count))
      .curve(d3.curveMonotoneX);

    
  }

  onMount(() => {
    updateWidth();
    initChart();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  });

  $: svgEl && data.length && updateChart();
</script>

<style>

</style>

<svg class={'sparkline'} bind:this={svgEl} {width} {height}></svg>
